import React, { useEffect, useMemo, useState } from 'react';
import { TopBar } from './components/TopBar';
import { PdfPreview } from './components/PdfPreview';
import { FormPanel } from './components/FormPanel';
import { FIELDS } from './components/fields';
export function App() {
  // Seed 3 fields filled to match the "3 filled • 4 remaining" spec
  const [values, setValues] = useState<Record<string, string>>({
    name: 'Jordan A. Rivera',
    dob: '04 / 17 / 1992',
    email: 'jordan.rivera@hey.com'
  });
  const [signatureDataUrl, setSignatureDataUrl] = useState<string | null>(null);
  const [activeId, setActiveId] = useState<string | null>('address');
  const total = FIELDS.length;
  const filled = useMemo(() => {
    return FIELDS.reduce((acc, f) => {
      if (f.type === 'signature') return acc + (signatureDataUrl ? 1 : 0);
      return acc + (values[f.id] ? 1 : 0);
    }, 0);
  }, [values, signatureDataUrl]);
  const handleChange = (id: string, value: string) => {
    setValues(v => ({
      ...v,
      [id]: value
    }));
  };
  const handleFieldClick = (id: string) => {
    setActiveId(id);
    // Focus the input in the side panel
    requestAnimationFrame(() => {
      const el = document.querySelector<HTMLInputElement>(`input[placeholder][data-field="${id}"]`);
      el?.focus();
    });
  };
  const handleDownload = () => {
    // Demo only — no real PDF generation
    console.log('Download signed PDF', {
      values,
      signatureDataUrl
    });
  };
  // Tab key hint — esc clears active
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActiveId(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return <div className="h-screen w-full flex flex-col bg-[#0e0e12] text-zinc-100 overflow-hidden" data-id="element-0">
      <TopBar filled={filled} total={total} fileName="lease-agreement-2026.pdf" data-id="element-1" />
      <main className="flex-1 flex min-h-0" data-id="element-2">
        <PdfPreview fields={FIELDS} activeId={activeId} values={values} signatureDataUrl={signatureDataUrl} onFieldClick={handleFieldClick} data-id="element-3" />
        <FormPanel values={values} signatureDataUrl={signatureDataUrl} activeId={activeId} setActiveId={setActiveId} onChange={handleChange} onSignatureChange={setSignatureDataUrl} onDownload={handleDownload} filled={filled} total={total} data-id="element-4" />
      </main>
    </div>;
}